import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { changeEmail, setPageTitle } from '../../actions';
import { Page } from '../../components';
import Button from '../../components/widgets/Button';
import { getAuthState, getProfile } from '../../selectors';
import {addUserEmail } from 'signoxe/actions';
import './styles.scss';

class ChangeEmailPage extends React.Component {
  static propTypes = {
    changeEmail: PropTypes.func.isRequired,
    setPageTitle: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired,
  };

  constructor(props) {
    console.log(`%c ${props}`, 'color:blue')
    super(props);
    this.state = {
      error: null,
    };
  }

  componentDidMount() {
    this.props.setPageTitle('Profile');
  }

  componentWillReceiveProps(nextProps) {
    // this.setState({error: nextProps.auth.error});
    // console.log(`%c ${nextProps}`, 'color:blue')
  }

  handleSubmit = (e) => {
    const id = localStorage.getItem('loggedInUserId')
    if (!this.loginForm.checkValidity()) return;
    e.preventDefault();
    const newEmail = this.newEmailInput.value;
    const newEmail2 = this.newEmail2Input.value;

    if (newEmail !== newEmail2) {
      this.setState({error: 'email mismatch'});

      return false;
    }
    this.props.addUserEmail({id, email: newEmail});
    this.newEmailInput.value = '';
    this.newEmail2Input.value = '';
  }

  render() {
    return (
      <Page className="email-change-page">
        <h3>Change email</h3>
        <form onSubmit={this.handleSubmit} ref={(elem) => this.loginForm = elem}>
          <input 
            id="new_email"
            name="new_email"
            required="required" 
            ref={(elem) => this.newEmailInput = elem}
            placeholder="New email"
            type="email"
          />
          <input 
            id="new_email_r"
            name="new_email_r"
            required="required"
            ref={(elem) => this.newEmail2Input = elem}
            placeholder="New email (again)"
            type="email"
          />
          <div className="error-message">
            {this.state.error}
          </div>
          <div className="success-message">
            {this.state.error === false ? 'email changed successfully.' : null}
          </div>
          <Button submit primary onClick={this.handleSubmit}>Change</Button>
        </form>
      </Page>
    );
  }
}

export default connect((state) => (
  {auth: getProfile(state)}
), {addUserEmail, setPageTitle})(ChangeEmailPage);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/containers/ChangeEmailPage/index.js